import axios, { AxiosResponse } from 'axios';

export /**
 * @method Get
 * @brief 센터별 세션 리뷰 조회
 */
const getSessionReviewAPI = async ({
    centerId,
    startDate,
    endDate,
    accessToken,
}: {
    centerId: string;
    startDate?: string;
    endDate?: string;
    accessToken: string;
}): Promise<any> => {
    let response = {} as AxiosResponse<any, any>;
    try {
        response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_SERVER}/v1/sessionReviews/${centerId}/centerSessionReview?startDate=${startDate}&endDate=${endDate}`,
            headers: { authorization: accessToken },
        });

        if (response.status === 200) {
            return response;
        }
    } catch (error: any) {
        // Error 😨
        switch (error.response.status) {
            case 400:
                return { status: error.response.status };
            case 409:
                alert('중복된 ID 입니다');
                return { status: error.response.status };
            case 500:
                return { status: error.response.status };
        }
    }
};
